<div class="main-container">
  <router-outlet></router-outlet>
  <app-spinner></app-spinner>
</div>
